// extracted by mini-css-extract-plugin
export var grid = "fc-stats-module--grid--d0b6e";
export var inner = "fc-stats-module--inner--c47a2";
export var item = "fc-stats-module--item--a7f63";
export var number = "fc-stats-module--number--bdcc5";
export var root = "fc-stats-module--root--3dbd3";
export var title = "fc-stats-module--title--72632";